import { useIsAuthenticated } from "@azure/msal-react";
import React, { useState } from "react";

import SignIn from "../msal/SignIn";
import GenericUtils from "../utils/GenericUtils";

export interface PageLayoutProps {
    children?: React.ReactNode;
}

function PageLayout({ children }: PageLayoutProps) {
    const isAuthenticated = useIsAuthenticated();

    const [autenticado, setAutenticado] = useState(false);

    return isAuthenticated &&
        (GenericUtils.getIsLocalAuthenticated() || autenticado) ? (
        <div>{children}</div>
    ) : (
        <SignIn setAutenticado={setAutenticado} />
    );
}

export default PageLayout;
